// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React from 'react';
// import axios from 'axios';
// import TodoInput from '../components/TodoInput';
import Header from '../components/Header';
import ParcelList from '../components/ParcelList';
import BarSearch from '../components/BarSearch';

const Route = () => {
  return (
    <>
      <Header />
      <div className={styles.root}>
        {/* <h1>Routes List</h1> */}
        <BarSearch textSearch={'Route NO.'} order={2} />
        <ParcelList />
      </div>
    </>
  );

  // async function start(username:string){
  //   const res = await axios.get(`http://122.155.201.108:8015/api/orders`)
  //       .then(res => {
  //         console.log(res);
  //         console.log(res.data);
  //         const {dealer,player ,result } = res.data
  //         dispatch({ type: 'updateGame', result: result });
  //         dispatch({ type: 'updateDealer', dealer: dealer });
  //         dispatch({ type: 'updatePlayer', player: player });
  //         setResult(result)
  //       })
  //     console.log(res)
  // }
}

const styles = {
  root: css`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1);
  // font-family: system-ui;
  margin: 0 auto;
  padding: 35px 24px 24px 24px;
  width: 90%;
  `,
};

export default Route;